/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST



// 获得奖品管理列表
export const getFairPrizeTable = params => {
  return axios.post(`${base}/query_fairprize`, params)
}
// 删除奖品
export const deleteFairPrize = id => {
  return axios.post(`${base}/delete_fairprize_${id}`)
}
// 创建奖品
export const createFairPrize = (params) => {
  return axios.post(`${base}/create_fairprize`, params)
}
// 修改奖品
export const editFairPrize = (params) => {
  return axios.post(`${base}/edit_fairprize_${params.id}`, params.data)
}
// 获取奖品详情
export const getFairPrizeDetail = (id = '') => {
  return axios.get(`${base}/get_fairprize_${id}`)
}
// 获取活动奖品/券类型
export const getFairPrizeOptions = () => {
  return axios.get(`${base}/fairprize_options`)
}
// 上传奖品图片
export const uploadFairPrizeImg = params => {
  return axios.post(`${base}/fairprize_option`, params)
}



// 获取奖品记录列表
export const getFairPrizeLogList = params => {
  return axios.post(`${base}/query_fairprize_log`, params)
}



// WEBPACK FOOTER //
// ./src/views/fair-prize/fairPrize.api.js